export interface ICustomService {
    catalogOfferCode: number;
    id: number;
    name: string;
    status: ESubscriptionStatus;
    subscriptionId: number;
}

export interface ISubscriptionResponse {
    catalogOfferCode: number;
    id: number;
    status: ESubscriptionStatus;
}

export interface IServicePage {
    content: IServiceResponse[];
}

interface IServiceResponse {
    domain: string;
    id: number;
    name: string;
    subscriptionId: number;
}

export enum ESubscriptionStatus {
    INITIAL = "INITIAL",
    ACTIVE = "ACTIVE",
    TERMINATED = "TERMINATED",
    CLOSED = "CLOSED",
}
